export const m = {
  EnterID: "클릭하여 Tada ID를 입력하세요",
  "select-specifications": "클릭하여 충전 규격을 고르세요",
  "check-account": "충전 계정 확인",
  whatID: "Tada ID는 뭐예요?",
  getID: "Tada ID를 입력하세요",
  maskgetID: "Tada ID를 입력하세요",
  "toastTips-format-error": "입력 오류",
  "toastTips-no-exist": "해당 ID 없음",
  toastTipsPlease: "먼저 충전 계정을 확인하세요",
  "common-problem": "자주 묻는 질문",
  "transaction-succeeded": "지불 성공",
  "transaction-failed": "지불 실패",
  "transaction-cancel": "지불 취소",
  "whether-account": "1.충전 완료 후 결과를 어떻게 확인할 수 있을까요?",
  "answer-whether-account":
    "충전 완료 후 앱으로 [내]-[지갑]에서 다이아몬드를 확인할 수 있습니다",
  "no-account": "2.충전 완료 후에 결제 상품이 지급되지 않으면 어떻게 해요?",
  "answer-no-account":
    "앱의 [소식]-[공식 소식]-[피드백과 도움]에서 질문을 제출하고 다음과 같은 정보를 제공해 주시면 저희 고객센터에서 도와드리겠습니다.",
  "recharge-money": "1.충전 금액과 계정 ID",
  "recharge-time": "2.충전 시간과 날짜",
  "recharge-shot": "3.지불 성공 프린트스크린",
  "recharge-wrong": "3.계정이나 금액을 잘못 충전하면 어떻게 해요?",
  "answer-recharge-wrong":
    "지불 비밀번호를 입력하시기 전에 반드시 충전계정의 ID와 충전금액 을 꼼꼼히 확인하신 후 구입하시기 바랍니다. 만약 잘못 충전하면 환불할 수 없습니다. 실제 충전된 ID의 사용자와 연락을 시도하여 보상하고자 하는지 여부를 상대방과 협상할 수 있습니다.",
  refund: "4.환불",
  "answer-refund": "죄송합니다! Tada는 환불 불가합니다.",
  "buy-enter-link":
    '다이아몬드를 구입하시면 링크를 통해 충전할 수 있습니다. <a class = "web-link" href = "https://pay.tadachat.info/">https://pay.tadachat.info</a> 링크를 모바일 브라우저에 복사하여 구매 페이지로 들어가 계정을 체크한 후, 해당 충전 규격을 선택하고 적절한 지불 방식을 통해 됩니다! 혜택이 많아요!',
  "buy-notice-a":
    "주의:<a>pay.tadachat.info</a> 는 Tada에서 유일한 공식 다이아몬드 구입 웹 인터넷 주소입니다",
  replace: "교체",
  sureBtn: "OK",
  "pay-style": "지불 방법 선택",
  goBack: "홈페이지로 돌아 가기",
  toastTips: "Tada ID를 입력하세요",
  rechargeFAQ_title: "자주 묻는 질문",
  PayStatusSuccess_title: "지불 성공",
  PayStatusFail_title: "지불 실패",
  PayStatusCancel_title: "지불 취소",
  Diamonds_title: "Tada 다이아몬드 충전 공식 사이트",
  "buy-notice":
    "pay.tadachat.info 는 Tada의 유일한 공식 다이아몬드 구매 웹 사이트입니다 고객 서비스 문의는 [메시지]-[공식 뉴스]-[피드백 및 도움말]로 이동하십시오.",
  RechargeHelp_title: "재충전 도움말",
  openAPP: "Tada APP 열기",
  "buy-diamonds-tit": "다이아몬드 서비스 구매",
  description:
    "Tada 의 유일한 공식 다이아몬드 충전 사이트입니다. Tada 는 국제형 사교 소프트웨어이며, 전세계 150개 이상의 국가 및 지구의 사용자는 Tada 를 사용하고 있습니다",
  keywords: "Tada 충전, Tada 다이아몬드 충전,Tada 공식충전,Tada 공식충전사이트",
  "payforType": " 충전 방법",
  trueText: "OK",
  falseText: "취소",
  alertShowTxt1: "",
  alertShowTxt3: "를 사용하여",
  alertShowTxt5: "다이아몬드를 충전 하시겠습니까?",
  EnterIDTip: " Tada 빠른 충전",
  scanLogin: "계정 개인 정보 및 보안을 위해 코드를 스캔하여 로그인하십시오.",
  scanTip:
    '팁 : Tada "개인 센터 / 역학"의 오른쪽 상단 모서리에있는 "스캔"을 클릭하여 코드를 스캔하여 로그인합니다. 동시에 QR 코드 스크린 샷을 식별하여 로그인 할 수 있습니다.',
  scanVersion:
    "Tada를 %s 버전으로 업그레이드하고 코드를 스캔하여 로그인하십시오.",
  delAccount: "계정 삭제",
  logout: "로그아웃",

  submit: "제출",
  email_place_holder: "편지함을 입력하십시오",
  contact_email: "이메일 연락처",
  provide_email: "결제 알림을 받으려면 이메일 주소를 입력하세요",
  email_address: "이메일 주소",
};



// WEBPACK FOOTER //
// ./src/lang/ko.js